import * as Sentry from "@sentry/react-native";
import { useField, useForm } from "mobx-easy-form";
import { Observer, observer } from "mobx-react";
import React from "react";
import * as yup from "yup";
import { TextInputV2 } from "~/components/V2/TextInputV2";
import { useErrorAlertV2 } from "~/components/V2/error-alert-v2";
import type { PetInstance } from "~/mobx/entities/pets/Pet";
import { EditPetModal } from "./EditPetModal";

export const InsuranceNumberInputModal = observer(
  function InsuranceNumberInputModal({
    isVisible,
    onClose,
    initialInsuranceNumber,
    pet,
  }: {
    isVisible: boolean;
    onClose: () => void;
    initialInsuranceNumber?: string | null;
    pet: PetInstance;
  }) {
    const errorAlert = useErrorAlertV2();

    const validationSchema = yup
      .string()
      .required()
      .test(
        "not-only-spaces",
        "Cannot be only spaces.",
        (value) => !!value && value.trim().length > 0,
      );

    const form = useForm({
      onSubmit: async ({ values }) => {
        try {
          await pet.updatePet({
            insuranceNumber: values.insuranceNumber,
          });
          onClose();
        } catch (error) {
          console.log(error);
          errorAlert(error);
          Sentry.captureException(error);
        }
      },
    });

    const insuranceNumber = useField({
      form,
      id: "insuranceNumber",
      initialValue: initialInsuranceNumber ?? "",
      validationSchema,
    });

    return (
      <>
        {isVisible && (
          <EditPetModal
            onSave={form.actions.submit}
            onClose={onClose}
            title={intl.formatMessage({
              id: "v+MoUK",
              defaultMessage: "Update insurance number",
              description:
                "Field for indicating the insurance number of a pet.",
            })}
          >
            <Observer>
              {() => {
                return (
                  <TextInputV2
                    value={insuranceNumber.state.value}
                    onChangeText={insuranceNumber.actions.onChange}
                    onFocus={insuranceNumber.actions.onFocus}
                    onBlur={insuranceNumber.actions.onBlur}
                    label={intl.formatMessage({
                      id: "XVF6up",
                      defaultMessage: "Insurance number",
                      description: "Placeholder for insurance number input",
                    })}
                    isError={!!insuranceNumber.computed.error}
                  />
                );
              }}
            </Observer>
          </EditPetModal>
        )}
      </>
    );
  },
);
